import request from '@/utils/request'

// 查询附件列表
export function listAttachment(query) {
  return request({
    url: '/web/attachment/list',
    method: 'get',
    params: query
  })
}

// 查询附件列表(不分页)
export function listAttachmentNoPage(query) {
  return request({
    url: '/web/attachment/listAll',
    method: 'get',
    params: query
  })
}

// 查询附件详细
export function getAttachment(fileId) {
  return request({
    url: '/web/attachment/' + fileId,
    method: 'get'
  })
}

// 新增附件
export function addAttachment(data) {
  return request({
    url: '/web/attachment',
    method: 'post',
    data: data
  })
}

// 修改附件
export function updateAttachment(data) {
  return request({
    url: '/web/attachment/edit',

    method: 'post',
    data: data
  })
}

// 删除附件
export function delAttachment(fileId) {
  return request({
    url: '/web/attachment/remove/' + fileId,

    method: 'post',
  })
}

// 导出附件
export function exportAttachment(query) {
  return request({
    url: '/web/attachment/export',
    method: 'get',
    params: query
  })
}

// 附件配置上传大小详细
export function getFileSize() {
  return request({
    url: '/web/attachment/getFileSize',
    method: 'get'
  })
}

// 查询附件上传列表
export function listNoPageAttachment(query) {
  return request({
    url: '/web/attachment/noPageList',
    method: 'get',
    params: query
  })
}

// 附件上传生成-上传附件id
export function getNewGuid() {
  return request({
    url: '/web/attachment/getNewGuid',
    method: 'get'
  })
}
